"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_cookie_1 = __importDefault(require("js-cookie"));
var baseLocaleProvider_1 = __importDefault(require("./baseLocaleProvider"));
var ClientLocaleProvider = /** @class */ (function (_super) {
    __extends(ClientLocaleProvider, _super);
    function ClientLocaleProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClientLocaleProvider.prototype.changeLocale = function (locale) {
        if (this.availableLocales.includes(locale)) {
            this.setDocumentLanguage(locale);
            this.saveLocale(locale);
        }
        return _super.prototype.changeLocale.call(this, locale);
    };
    ClientLocaleProvider.prototype.setDefaultLocale = function (defaultLocale) {
        if (!defaultLocale) {
            defaultLocale = this.getSavedLocale();
        }
        if (!defaultLocale) {
            defaultLocale = this.getDefaultClientLocale();
        }
        _super.prototype.setDefaultLocale.call(this, defaultLocale);
        this.setDocumentLanguage(this.locale);
    };
    ClientLocaleProvider.prototype.setDocumentLanguage = function (locale) {
        document.documentElement.lang = locale;
    };
    ClientLocaleProvider.prototype.getSavedLocale = function () {
        return js_cookie_1.default.get(ClientLocaleProvider.COOKIE_NAME);
    };
    ClientLocaleProvider.prototype.saveLocale = function (locale) {
        js_cookie_1.default.set(ClientLocaleProvider.COOKIE_NAME, locale);
    };
    ClientLocaleProvider.prototype.getDefaultClientLocale = function () {
        var _this = this;
        return (window.navigator.languages || [window.navigator.language]).find(function (language) { return _this.availableLocales.includes(language); });
    };
    ClientLocaleProvider.COOKIE_NAME = "app-locale";
    return ClientLocaleProvider;
}(baseLocaleProvider_1.default));
exports.default = ClientLocaleProvider;
